import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class EventStatusChangedNotification extends Notification {
  icon() {
    return 'fas fa-calendar-check';
  }

  href() {
    const data = this.attrs.notification.content();
    return data.discussionId ? app.route('discussion', { id: data.discussionId }) : '#';
  }

  content() {
    const data = this.attrs.notification.content();
    return app.translator.trans('florcarioca-rsvp.forum.notifications.event_status_changed_text', {
      event_title: data.eventTitle,
    });
  }

  excerpt() {
    const data = this.attrs.notification.content();
    return app.translator.trans(`florcarioca-rsvp.forum.notifications.status_${data.newStatus}`);
  }
}
